/**
 * @file header
 * @author 陈恩浩
 */

import React, { Component } from "react";
import User from "../user";
import "./index.scss";

import { changePopup, changeMenu } from "src/redux/basicInfo";
import { connect } from "react-redux";

@connect((state) => state, { changePopup, changeMenu })
class Header extends Component {
  constructor(props) {
    super(props);
    this.state = {
      status: false,
    };
  }

  componentDidMount() {
    window.addEventListener("scroll", this.handleScroll);
  }

  componentWillUnmount() {
    // window.removeEventListener('scroll', this.handleScroll)
  }

  handleScroll = (event) => {
    //滚动条高度
    let scrollTop =
      document.documentElement.scrollTop || document.body.scrollTop; //滚动条滚动高度
    if (scrollTop > 1) {
      this.setState({ status: true });
    } else {
      this.setState({ status: false });
    }
  };

  handleClick = (param) => {
    if (param.path === "/experience") {
      this.props.changePopup({ type: "trial", status: true });
    } else {
      this.props.changeMenu(param.current);
      this.props.history.push({
        pathname: param.path,
      });
    }
  };

  handleClickLan = () => {
    // let { i18n } = this.props;
    // i18n.changeLanguage(switchLan());
    // window.location.reload();
    window.location.href = "https://www.ihatoo.com/en/junior";
  };

  handleClickLogin = () => {
    this.props.changePopup({ type: "login", status: true });
  };

  handleClickRegister = () => {
    this.props.changePopup({ type: "register", status: true });
  };

  render() {
    let { status } = this.state;

    return (
      <div className={status ? "header header-active" : "header"}>
        <div className="header-left">
          <div
            className="logo"
            // onClick={() => this.handleClick({ path: "/", current: 1 })}
          ></div>
        </div>
      </div>
    );
  }
}

export default Header;
